import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-conditional-text-renderer',
    templateUrl: './conditional-text-renderer.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class ConditionalTextRendererComponent implements ICellRendererAngularComp {
    param: string;
    public result: number;
    constructor() { }

    initilize(params: ICellRendererParams) {
        if (params.data) {
            this.result = params.data.caResult
        }
    }

    agInit(params: any): void {
        this.initilize(params);

    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}